import { Injectable } from '@angular/core';
import { ChangePassword, OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { BaseApiService } from '@shared/data-access';
import { NotificationService } from '@shared/feature/notification-handling';
import { first, switchMap } from 'rxjs';
import { OfficerChangedPin } from '../models/officer-changed-pin.model';
import { TranslationFromJsonService } from '@shared/feature/translate';

@Injectable({
  providedIn: 'root',
})
export class EditProfileService {
  constructor(
    public api: BaseApiService,
    public notificationService: NotificationService,
    public facade: OfficerDetailFacade,
    private translationService: TranslationFromJsonService
  ) {}

  changeLoggedInOfficerPin(changedPin: string, officerUid?: string): void {
    (officerUid
      ? this.api.patch(`/api/users/${officerUid}/pin`, new OfficerChangedPin(changedPin))
      : this.facade.getLoggedInOfficer().pipe(
          first(),
          switchMap((loggedInOfficer) => {
            return this.api.patch(`/api/users/${loggedInOfficer.uid}/pin`, new OfficerChangedPin(changedPin));
          })
        )
    ).subscribe({
      next: () => {
        this.notificationService.addSuccess(this.translationService.instant('pin-changed-successfully'));
      },
    });
  }

  editPassword(newPassword: string): void {
    this.facade
      .getLoggedInOfficer()
      .pipe(
        first(),
        switchMap((loggedInOfficer) => this.api.patch(`api/users/${loggedInOfficer.uid}/password`, new ChangePassword(newPassword)))
      )
      .subscribe({
        next: () => this.notificationService.addSuccess(this.translationService.instant('password-changed-successfully')),
      });
  }
}
